import type { Ministerio } from '@/types'

export const mockMinisterios: Ministerio[] = [
  {
    id: '1',
    nome: 'Ministério de Louvor',
    descricao: 'Ministério responsável pela adoração e louvor nos cultos e eventos da igreja',
    grupoFuncoes: 'louvor',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174003',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-10T10:00:00Z',
    updated_at: '2024-01-10T10:00:00Z',
  },
  {
    id: '2',
    nome: 'Ministério de Jovens',
    descricao: 'Ministério voltado para o desenvolvimento espiritual e social dos jovens da igreja',
    grupoFuncoes: 'jovens',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174001',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-12T10:00:00Z',
    updated_at: '2024-01-12T10:00:00Z',
  },
  {
    id: '3',
    nome: 'Ministério de Crianças',
    descricao: 'Ministério dedicado ao ensino bíblico e recreação para crianças de 3 a 12 anos',
    grupoFuncoes: 'infantil',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174004',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-01-15T10:00:00Z',
  },
  {
    id: '4',
    nome: 'Ministério de Ação Social',
    descricao: 'Ministério focado em projetos sociais e apoio à comunidade carente',
    grupoFuncoes: 'social',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174003',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-18T10:00:00Z',
    updated_at: '2024-01-18T10:00:00Z',
  },
  {
    id: '5',
    nome: 'Ministério de Intercessão',
    descricao: 'Ministério dedicado à oração e intercessão pela igreja e nações',
    grupoFuncoes: 'oracao',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174001',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-20T10:00:00Z',
    updated_at: '2024-01-20T10:00:00Z',
  },
  {
    id: '6',
    nome: 'Ministério de Recepção',
    descricao: 'Ministério responsável por recepcionar e acolher visitantes e membros',
    grupoFuncoes: 'recepcao',
    lider_perfil_id: '123e4567-e89b-12d3-a456-426614174004',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    ativo: true,
    created_at: '2024-01-22T10:00:00Z',
    updated_at: '2024-01-22T10:00:00Z',
  },
]

export const mockMinisteriosAtivos = mockMinisterios.filter((m) => m.ativo)
